// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Products_UploadImageResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract for POST /so/products/upload_image
 *
 * Returns metadata about the just-uploaded product gallery image: the new
 * DB id, the server-generated safe filename, and Azure Blob URLs (with SAS
 * tokens for the private container) for the original and the thumbnail,
 * plus the gallery-positioning fields the controller resolved
 * (sort_order, is_primary).
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface Products_UploadImageResponseDados {
so_product_image_id: number
so_product_image_filename: string
so_product_image_url: string
so_product_image_thumbnail_url: string
so_product_image_sort_order: number
so_product_image_is_primary: boolean
so_product_image_alt_text?: string
}

export type Products_UploadImageResponse = ApiResponse<Products_UploadImageResponseDados>;

registerResponseContract('Products_UploadImageResponse', {
  so_product_image_id:            { type: 'number',  required: true },
  so_product_image_filename:      { type: 'string',  required: true },
  so_product_image_url:           { type: 'string',  required: true },
  so_product_image_thumbnail_url: { type: 'string',  required: true },
  so_product_image_sort_order:    { type: 'number',  required: true },
  so_product_image_is_primary:    { type: 'boolean', required: true },
  so_product_image_alt_text:      { type: 'string',  required: false },
})
